const types = {
  //Get Request List
  GET_CLIENT_REQUEST_START: "GET_CLIENT_REQUEST_START",
  GET_CLIENT_REQUEST_SUCCESS: "GET_CLIENT_REQUEST_SUCCESS",
  GET_CLIENT_REQUEST_ERROR: "GET_CLIENT_REQUEST_ERROR",
  GET_CLIENT_REQUEST_RESET: "GET_CLIENT_REQUEST_RESET",

  //Create Request
  CREATE_CLIENT_REQUEST_START: "CREATE_CLIENT_REQUEST_START",
  CREATE_CLIENT_REQUEST_SUCCESS: "CREATE_CLIENT_REQUEST_SUCCESS",
  CREATE_CLIENT_REQUEST_ERROR: "CREATE_CLIENT_REQUEST_ERROR",
  CREATE_CLIENT_REQUEST_RESET: "CREATE_CLIENT_REQUEST_RESET",

  //Update Request
  UPDATE_CLIENT_REQUEST_START: "UPDATE_CLIENT_REQUEST_START",
  UPDATE_CLIENT_REQUEST_SUCCESS: "UPDATE_CLIENT_REQUEST_SUCCESS",
  UPDATE_CLIENT_REQUEST_ERROR: "UPDATE_CLIENT_REQUEST_ERROR",
  UPDATE_CLIENT_REQUEST_RESET: "UPDATE_CLIENT_REQUEST_RESET",

  //Delete Request
  DELETE_CLIENT_REQUEST_START: "DELETE_CLIENT_REQUEST_START",
  DELETE_CLIENT_REQUEST_SUCCESS: "DELETE_CLIENT_REQUEST_SUCCESS",
  DELETE_CLIENT_REQUEST_ERROR: "DELETE_CLIENT_REQUEST_ERROR",
  DELETE_CLIENT_REQUEST_RESET: "DELETE_CLIENT_REQUEST_RESET",

  //Single Request
  SINGLE_CLIENT_REQUEST_START: "SINGLE_CLIENT_REQUEST_START",
  SINGLE_CLIENT_REQUEST_SUCCESS: "SINGLE_CLIENT_REQUEST_SUCCESS",
  SINGLE_CLIENT_REQUEST_ERROR: "SINGLE_CLIENT_REQUEST_ERROR",
  SINGLE_CLIENT_REQUEST_RESET: "SINGLE_CLIENT_REQUEST_RESET",
};

export default types;

